import { Button, Modal } from 'semantic-ui-react';
import { ImpactType } from '../../../../types';
import ImportImpact from '../importImpact';

type ApplyConfirmationModalPropsType = {
    open: boolean;
    closeModal: (data: any) => void;
    onConfirm: (data: any) => void;
    impact: ImpactType;
};
function ApplyConfirmationModal({ open, closeModal, impact: impact, onConfirm }: ApplyConfirmationModalPropsType) {
    return (
        <Modal size="large" open={open} onClose={closeModal}>
            <Modal.Header>Are you sure that you want to apply the following changes?</Modal.Header>
            <Modal.Content>
                <ImportImpact impact={impact} />
            </Modal.Content>
            <Modal.Actions>
                <Button positive onClick={onConfirm}>
                    APPLY
                </Button>
                <Button secondary onClick={closeModal}>
                    CANCEL
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default ApplyConfirmationModal;
